module.exports = __webpack_public_path__ + "ab047fd575efbe56e4a69aa22dc39b62.svg";